import { examInfo } from './type'
import V202206 from './51220061'
import V202209 from './51220091'

const infos: { [exmaId: string]: examInfo } = {
  '51220061': V202206, // 2022年度6月WEB完結型テスト
  '51220091': V202209 // 2022年度9月とじ込み型テスト
}

export default infos
